import i18n from 'i18n'

// Source-type display labels: the merchant's own label from app_config wins,
// otherwise the translated default. Resolved at render time (not when the
// config loads) so the defaults follow a late switch to fr-CA.
export const resolveTypeLabels = (merchantLabels: Record<string, string>): Record<string, string> => {
  const labels: Record<string, string> = {
    mined: i18n.t('sourceTypes.mined'),
    'lab grown': i18n.t('sourceTypes.labGrown')
  }
  for (const [name, label] of Object.entries(merchantLabels)) {
    if (label) labels[name] = label
  }
  return labels
}
